export const TRUSTPILOT_CONFIG = {
  businessunitId: '692e52c5f1d0c4ceec11f6da',
  templateId: '56278e9abfbbba0bdcd568bc',
  token: '3a0b342f-e43d-42bb-b2e7-0d407fbd5153',
  locale: 'en-US',
  reviewUrl: 'https://www.trustpilot.com/review/godyspo.com',
  scriptUrl: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
} as const;
